import type { ComponentType } from "react";
import {
  MarkerType,
  type Edge,
  type EdgeMarker,
  type EdgeProps,
} from "reactflow";
import { EdgeType } from "app/lib/pipeline/Parser";
import DependencyEdge from "./DependencyEdge";

export const edgeTypes = {
  [EdgeType.Explicit]: DependencyEdge as ComponentType<EdgeProps>,
  [EdgeType.Implicit]: DependencyEdge as ComponentType<EdgeProps>,
};

export function markerEndForEdge(edge: Edge): EdgeMarker {
  switch (edge.type) {
    default:
      return {
        type: MarkerType.Arrow,
        color: "#bbb",
        height: 24,
        width: 24,
        strokeWidth: 1,
      };
  }
}
